import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { alertFailure, alertSuccess } from "../../../store/actions/alert";
import useStyles from "./style";
import CustomAccordion from "./CustomAccordion";
import InputField from "./TextField";
import CustomButton from "./Button";
import { apiRoute, convertToTransaction, deriveTokenAccount, SendSolanaTransaction } from "../../../utils";
import { BaseRequest } from "../../../request/Request";

export default function RefundRemainingTokens({
  vaultAddress,
  pool_index,
  poolId,
  multiSigWallet,
  isValidVault,
  owner,
  disableButton,
  poolDetail
}: any) {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [walletAddress, setWalletAddress] = useState("");
  const [errors, setErrors] = useState<any>("");
  const [loading, setLoading] = useState<any>(false);

  const handleWalletAddressChange = (e: any) => {
    if (walletAddress) {
      setErrors((prevErrors: any) => {
        const { walletAddress, ...remainingErrors } = prevErrors;
        return remainingErrors;
      });
    }
    setWalletAddress(e.target.value);
  };

  useEffect(() => {
    if (walletAddress) {
      setErrors((prevErrors: any) => {
        const { walletAddress, ...remainingErrors } = prevErrors;
        return remainingErrors;
      });
    }
  }, [walletAddress]);

  const refundRemainingTokens = async () => {
    if (!window?.solana?.publicKey) {
      dispatch(alertFailure("Please Connect Solana Wallet"));
      return;
    }
    if(!pool_index) {
      dispatch(alertFailure("Pool is not deployed"))
      return;
    }
    if (!multiSigWallet) {
      dispatch(alertFailure("Please Enter MultiSig Wallet Address"));
      return;
    }
    if (!vaultAddress) {
      dispatch(alertFailure("Please Enter Vault Address"));
      return;
    }
    if(owner && !isValidVault) {
      dispatch(alertFailure("Vault Address should be the owner of Pool"));
      return;
    }
    const errors: any = {};
    if (!walletAddress) {
      errors.walletAddress = "Wallet Address is required";
    }
    if (Object.keys(errors).length === 0) {
      try {
        setLoading(true)
        const tokenAddress = deriveTokenAccount(walletAddress, poolDetail?.token).toBase58();
        const squads_multi_sig_address = multiSigWallet;
        const baseRequest = new BaseRequest();
        let url = apiRoute(`/solana-multisig/refund-remaining-tokens`);
        const body = {
          squads_multi_sig_address: squads_multi_sig_address, 
          campaign_id: poolId, 
          wallet: tokenAddress,
          fee_payer: window?.solana?.publicKey.toString()
      }
        const response = (await baseRequest.post(url, body)) as any;
        const result = await response.json();
        const data = result.data;
        const tx = await convertToTransaction(data)
        const sig = await SendSolanaTransaction(tx);
        dispatch(alertSuccess("Transaction Successfull"));
        setWalletAddress("");
        setLoading(false);
      } catch (error) {
        dispatch(alertFailure("Transaction failed"));
        setWalletAddress("");
        setLoading(false);
      }
    } else {
      setErrors(errors);
    }
  };
  return (
    <div className={classes.spaceAbove}>
      <CustomAccordion title="Refund Remaining Tokens">
        <div className={classes.columnFlex}>
          <InputField
            label="Enter Wallet Address"
            id="tokenMint"
            value={walletAddress}
            onChange={handleWalletAddressChange}
            error={errors.walletAddress}
            disableButton = {disableButton}
          />
          <CustomButton disableButton = {disableButton} loading = {loading} onClick={() => refundRemainingTokens()} />
        </div>
      </CustomAccordion>
    </div>
  );
}
